<div class="card">
  <form class="card-body py-3 px-4" [ngClass]="{ 'pb-0': open }" autocomplete="off" (submit)="onSubmit()">
    <div *ngIf="isTablet$ | async" (click)="toggleOpen()" class="cursor-pointer d-print-none">
      <div class="d-flex justify-content-between">
        <div>
          <b>{{ header | translate }}</b>
          <button class="open-button" type="button">
            <icon-toggle-open-close [open]="open"></icon-toggle-open-close>
          </button>
        </div>
        <div>
          <button
            *ngIf="showExcel && !open && (isTablet$ | async)"
            type="button"
            class="ml-3 btn btn-outline-secondary btn-square"
            (click)="exportAsExcel.emit()"
            [disabled]="excelDisabled"
          >
            <icon-excel class="icon-excel-container"></icon-excel>
          </button>

          <button
            *ngIf="showBatchExport && !open && (isTablet$ | async)"
            type="button"
            class="ml-3 btn btn-outline-secondary btn-square"
            (click)="onBatchExport()"
          >
            <i class="fa fa-file-archive-o"></i>
          </button>

          <button
            *ngIf="showPrint && !open && (isTablet$ | async)"
            type="button"
            class="ml-3 btn btn-outline-secondary btn-square"
            (click)="onPrint()"
            [disabled]="printDisabled"
          >
            <i class="fa fa-print" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="open || !(isTablet$ | async)" class="form-row pt-2">
      <ng-content></ng-content>

      <div class="d-flex justify-content-between d-print-none flex-wrap action-container order-last" [ngClass]="submitZoneClass">
        <div class="d-flex custom-actions flex-wrap flex-sm-nowrap">
          <ng-content select="[footer-actions]"></ng-content>
        </div>
        <div class="d-flex justify-content-end flex-grow-1 main-actions">
          <button
            *ngIf="showClearAll"
            type="button"
            (click)="onClearFilters()"
            class="btn btn-outline-secondary btn-square"
            [disabled]="disableSearch"
          >
            {{ "BUTTON.CLEAR_ALL" | translate }}
          </button>
          <button type="submit" class="btn btn-primary btn-square" [disabled]="disableSearch">
            {{ "BUTTON.SEARCH" | translate }}
          </button>
          <div class="line" *ngIf="showExcel || showPrint"></div>
          <button
            *ngIf="showExcel"
            type="button"
            class="btn btn-outline-secondary btn-square"
            (click)="exportAsExcel.emit()"
            [disabled]="excelDisabled"
          >
            <icon-excel class="icon-excel-container"></icon-excel>
          </button>

          <button *ngIf="showBatchExport" type="button" class="btn btn-outline-secondary btn-square" (click)="onBatchExport()">
            <i class="fa fa-file-archive-o"></i>
          </button>

          <button
            *ngIf="showPrint"
            type="button"
            class="btn btn-outline-secondary btn-square"
            (click)="onPrint()"
            [disabled]="printDisabled"
          >
            <i class="fa fa-print" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
